// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3dBYU","Label":"Checkbox_Label__1nLb-","InputElement":"Checkbox_InputElement__TpF9d","Invalid":"Checkbox_Invalid__28d8G"};